<template>
  <div class="h-full">
    <!-- Using the route's fullPath as a key forces the component to re-render on navigation -->
    <router-view :key="route.fullPath" class="h-full" />
    <!-- Global confirm dialog host -->
    <ConfirmDialogHost />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import ConfirmDialogHost from '@components/ui/ConfirmDialogHost.vue';
import { useSeo } from '@/composables/useSeo';

const route = useRoute();

// Default SEO handling for static pages using route meta
useSeo({
  title: () => route.meta.title || "Spin the Names | Random Name Picker Wheel",
  description: () => route.meta.description || "Free and easy to use name spinner. Used by teachers and for raffles. Enter names, spin wheel to pick a random winner. Customize look and feel, save and share wheels.",
  robots: () => route.meta.robots,
  ogType: () => route.meta.ogType || "website"
});
</script>
